module.exports = __webpack_public_path__ + "img/corps_ban.png";